import React from 'react';
import { FlameIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type FinalCTAProps = {
  guaranteeEnabled: boolean;
};
const situations = ['Un circuito que dejó de funcionar.', 'Una instalación antigua con modificaciones.', 'Un problema que aparece solamente en determinados momentos.', 'Un resultado de medición que necesitás interpretar.', 'O un presupuesto que tenés que preparar para tu cliente.'];
export function FinalCTA({
  guaranteeEnabled
}: FinalCTAProps) {
  return <section className="bg-blue-950 px-4 py-7 text-center md:px-12" data-id="element-39" data-mp="vui4z3cc56c1">
      <h2 className="text-2xl font-extrabold uppercase leading-tight tracking-tight text-amber-400 md:text-3xl" data-id="element-40" data-mp="vwunpipx3kq5">
        Una última pregunta...
      </h2>
      <div className="mx-auto mt-2 max-w-xl space-y-1.5 text-sm leading-snug text-white md:text-base" data-id="element-41" data-mp="14whlzvncoaez">
        <p data-id="element-42" data-mp="zxekgl6kwmbr">
          ¿Cuántas veces llegaste a un trabajo donde sabías que existía una falla eléctrica, pero necesitabas más
          información para comprender qué estaba pasando?
        </p>
        <ul className="space-y-0.5 text-slate-300" data-id="element-43" data-mp="2h4sqykgexxvd">
          {situations.map(s => <li key={s} data-id="element-44" data-mp="2m2ks852y6wc8">{s}</li>)}
        </ul>
        <p data-id="element-45" data-mp="2m57065tr3duz">
          Podés seguir reuniendo apuntes, buscando ejemplos en diferentes lugares y preparando tus herramientas desde
          cero.
        </p>
        <p className="font-bold" data-id="element-46" data-mp="2v2r3dkb6bk88">
          O podés tener un sistema completo de consulta profesional, organizado para encontrar cada recurso cuando lo
          necesites.
        </p>
        <p className="text-slate-300" data-id="element-47" data-mp="34t2b7hxzadke">
          Diagnósticos prácticos, diagramas eléctricos, casos resueltos y herramientas profesionales. Todo en un solo
          lugar.
        </p>
      </div>
      <p className="mt-2 text-sm font-extrabold uppercase text-amber-400" data-id="element-48" data-mp="3esb0vylt960y">Identificá. Analizá. Diagnosticá. Resolvé.</p>

      <div className="mx-auto mt-4 max-w-[220px]" data-id="element-49" data-mp="3itwgvstn60fd">
        <ProductImage data-id="element-50" data-mp="1jo3i5j6gg94k" />
      </div>

      <h3 className="mx-auto mt-3 max-w-xl text-2xl font-extrabold uppercase leading-tight tracking-tight text-white md:text-3xl" data-id="element-51" data-mp="1jpeita4lt0rg">
        <ZapIcon className="mr-1 inline h-6 w-6 -translate-y-0.5 fill-amber-400 text-amber-400" aria-hidden data-id="element-52" data-mp="1en5qmfzk22qe" />
        Combo Completo Electricistas
      </h3>
      <p className="mx-auto mt-1 max-w-xl text-xs font-bold uppercase leading-tight text-white md:text-sm" data-id="element-53" data-mp="1novsyguz6m2y">
        El sistema completo de diagnóstico y soluciones eléctricas, listo para usar.
      </p>
      <p className="mt-1.5 text-sm leading-snug text-sky-100" data-id="element-54" data-mp="1xeot8lpo3erw">
        Disyuntores y térmicas • Circuitos domiciliarios • Instalaciones antiguas • Diagnóstico profesional
      </p>
      <p className="mt-3 flex flex-wrap items-center justify-center gap-1.5 text-base font-extrabold uppercase leading-tight text-amber-400" data-id="element-55" data-mp="27dedum8y7dbu">
        <FlameIcon className="h-4 w-4 shrink-0" strokeWidth={2.5} aria-hidden data-id="element-56" data-mp="h1rwoi5bzk1g" />
        ¡Conseguí el Combo Completo hoy mismo!
      </p>
      <p className="mt-1 text-xs font-bold uppercase text-white/80" data-id="element-57" data-mp="2vy919577po3">4 tomos principales + 4 bonos profesionales</p>
      <div className="mt-3" data-id="element-58" data-mp="6y32o7vncmaq">
        <CtaButton mode="scroll" subtext="Acceso inmediato • Entrega digital • Pago único" data-id="element-59" data-mp="6w9v8qd7ly1o">
          ¡Quiero acceder al sistema completo!
        </CtaButton>
      </div>
      <p className="mx-auto mt-3 max-w-md text-xs font-bold uppercase leading-snug text-white" data-id="element-60" data-mp="3ua409e63aj2u">
        {guaranteeEnabled && <>
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-sky-400" aria-hidden data-id="element-61" data-mp="3fc1wb2v5bvl2" />
            Garantía de 7 días según condiciones •{' '}
          </>}
        Material profesional en español argentino
      </p>
    </section>;
}